export const experience = [
  {
    company: "ParkSpot",
    role: "Software Developer Intern",
    duration: "Nov 2024 - Present",
    description: [
      "Optimized Application Performance: Identified and resolved 20+ critical bugs, enhancing app speed by 25% and delivering a smoother, more reliable user experience.",
      " Developed New Features: Engineered and deployed 10+ new features, boosting platform functionality and user engagement by 30%.",
      "Created REST APIs in Go: Designed and implemented scalable RESTful APIs using Go, improving backend efficiency and system performance.",
    ],
    dir: "left",
  },
  {
    company: "GirlScript Summer of Code",
    role: "Open Source Contributor",
    duration: "Jul 2024 - Aug 2024",
    description: [
      "Merged over 65 pull requests to enhance both frontend and backend functionality, contributing significantly to the project’s overall improvement.",
      "Implemented and deployed 10+ new features, including user authentication and responsive UI components, resulting in a 30% boost in performance and user engagement.",
      "Collaborated with a team of 15+ developers, identifying and resolving 40+ bugs while maintaining clean code standards through Git and GitHub version control.",
    ],
    dir: "right",
  },
  {
    company: "PnInfosys",
    role: "Web Designer Intern",
    duration: "Dec 2022 - Apr 2023",
    description: [
      "Applied responsive design principles and mobile-first development to create user-centric and adaptable web interfaces, ensuring optimal performance across various devices.",
      "Collaborated with mentors to enhance web design skills",
      "Developed and maintained websites, focusing on usability and user experience.",
    ],
    dir: "left",
  },
];

export const RESUME_URL =
  "https://drive.google.com/file/d/1R6wnQ4i-NDbCLMhrf5RWdm02BtFGXcYN/view?usp=sharing";
